import { useEffect, useState } from 'react'

import { ACADEMY_MENU_ROUTES } from '../academy-mobile-menu.const'
import type { CategoryNode } from '../types'
import { findExpandedCategoriesForArticle } from '../utils/categoryTreeUtils'

type UseExpandedCategoriesParams = {
  currentTutorialPath?: string
  isDocumentationPage: boolean
  documentationCategoryTree: CategoryNode[]
  quickStartCategoryTree: CategoryNode[]
}

export function useExpandedCategories({
  currentTutorialPath,
  isDocumentationPage,
  documentationCategoryTree,
  quickStartCategoryTree,
}: UseExpandedCategoriesParams) {
  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(() => new Set())

  useEffect(() => {
    if (!currentTutorialPath) return

    const basePath = isDocumentationPage ? ACADEMY_MENU_ROUTES.documentation : ACADEMY_MENU_ROUTES.quickStart
    const categoryTree = isDocumentationPage ? documentationCategoryTree : quickStartCategoryTree

    const expandedPaths = findExpandedCategoriesForArticle(categoryTree, currentTutorialPath, basePath)

    if (expandedPaths.length > 0) {
      setExpandedCategories(new Set(expandedPaths))
    }
  }, [currentTutorialPath, isDocumentationPage, documentationCategoryTree, quickStartCategoryTree])

  const toggleCategory = (categoryPath: string) => {
    setExpandedCategories((prev) => {
      const next = new Set(prev)
      if (next.has(categoryPath)) {
        next.delete(categoryPath)
      } else {
        next.add(categoryPath)
      }
      return next
    })
  }

  return { expandedCategories, toggleCategory }
}
